import {
    RATING_LIST_ACTION, RATING_LIST_SUCCESS,
    RATING_APPROVE_ACTION, RATING_APPROVE_SUCCESS,
    RATING_DELETE_ACTION, RATING_DELETE_SUCCESS,
    RATING_REPLY_APPROVE_ACTION, RATING_REPLY_APPROVE_SUCCESS,
    RATING_REPLY_DELETE_ACTION, RATING_REPLY_DELETE_SUCCESS,
} from '../constants/Types';

export const getListRatings = (filters) => ({ type: RATING_LIST_ACTION, filters });
export const setListRatings = (data) => ({ type: RATING_LIST_SUCCESS, ratings: data.ratings, ...data });

export const approveRatingAction = (rating) => ({ type: RATING_APPROVE_ACTION, rating });
export const approveRatingSuccess = (rating) => ({ type: RATING_APPROVE_SUCCESS, rating });

export const deleteRatingAction = (rating, refreshParams) => ({ type: RATING_DELETE_ACTION, rating, refreshParams });
export const deleteRatingSuccess = (rating) => ({ type: RATING_DELETE_SUCCESS, rating });

export const approveRatingReplyAction = (reply) => ({ type: RATING_REPLY_APPROVE_ACTION, reply });
export const approveRatingReplySuccess = (reply) => ({ type: RATING_REPLY_APPROVE_SUCCESS, reply });

export const deleteRatingReplyAction = (reply, refreshParams) => ({ type: RATING_REPLY_DELETE_ACTION, reply, refreshParams });
export const deleteRatingReplySuccess = (reply) => ({ type: RATING_REPLY_DELETE_SUCCESS, reply });
